<template>
  <footer class="page-footer">
    <div class="container">
      <div class="page-footer__row">
        <router-link
          v-if="prev"
          :to="prev"
          :disabled="isDisabled"
          class="page-footer__link page-footer__link_prev"
        >
          Предыдущая
        </router-link>

        <router-link
          v-if="next"
          :to="next"
          :disabled="isDisabled"
          class="page-footer__link page-footer__link_next"
        >
          Cледующая
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
  props: {
    next: {
      type: [String, Object],
      default: ''
    },
    prev: {
      type: [String, Object],
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isDisabled: this.disable
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keydownEvent, false)
    window.addEventListener('wheel', this.scrollEvent, false)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keydownEvent, false)
    window.removeEventListener('wheel', this.scrollEvent, false)
  }
  /* methods: {
    keydownEvent (e) {
      if (this.isDisabled) return

      if (e.keyCode === 37) {
        this.handleGlobalKeyLeft()
      }
      if (e.keyCode === 39) {
        this.handleGlobalKeyRight()
      }
    },
    scrollEvent (e) {
      if (this.isDisabled) return

      if (e.deltaY >= 10 && this.next) {
        this.changeRoute(this.next)
      }

      if (e.deltaY <= -10 && this.prev) {
        this.changeRoute(this.prev)
      }
    },
    handleGlobalKeyRight () {
      if (!this.next) return
      this.changeRoute(this.next)
    },
    handleGlobalKeyLeft () {
      if (!this.prev) return
      this.changeRoute(this.prev)
    },
    changeRoute (path) {
      this.isDisabled = true
      this.$router.push(path)
    }
  } */
}
</script>
